import { PUBLIC_PATHS } from '~/constants/publicPaths';
import { AccountRepository } from '~/repository/AccountRepository';

/**
 * アカウント申請状況確認ミドルウェア
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const loginUserStore = useLoginUserStore();

  // ログインユーザーが取得できない場合はスキップ（auth.global.tsで処理される）
  if (!loginUserStore.loginUser) {
    return;
  }

  // 認証不要パスの場合はスキップ
  if (PUBLIC_PATHS.includes(to.path)) {
    return;
  }

  // 申請状況確認APIで申請状況を取得する
  const accountRepository = new AccountRepository('0-00');
  const response = await accountRepository.getApplicationStatus();

  // 申請中かどうかをストアに設定
  loginUserStore.setIsInApplication(response.data?.isPending ?? false);
});
